import { IFetchListRequestPayload } from '@interfaces/common';
import {
  IImportHighRiskSupplementsListResponse,
  IImportMedicationsResponse,
  IImportSynonymsListResponse,
  IMedicationDetails,
  IMedicationResponseDetails,
  IMedicationSettings,
  IMedicationsSearchResult,
  ISubmitMedicationNeedsInfoFormPayload,
  IUserEnteredMedication,
  IUserEnteredMedicationData,
  IUserEnteredMedicationResponseDto,
} from '@interfaces/medications';

import { apiUrls } from './urls';
import { get, post, postFormWithFiles, put, putFormWithFiles, upload } from './utils';

export const getMedicationSettings = () =>
  get<IMedicationSettings>(apiUrls.lookups.medicationSettings);

export const searchMedications = (payload: IFetchListRequestPayload) =>
  post<IMedicationsSearchResult>(apiUrls.medications.search, payload);

export const getMedicationDetails = (id: number) =>
  get<IMedicationDetails>(`${apiUrls.medications.details}/${id}`);

export const importCSVFile = (file: File) =>
  upload<IImportMedicationsResponse>(apiUrls.medications.importCSVFile, file);

export const importSynonymsListCSVFile = (file: File) =>
  upload<IImportSynonymsListResponse>(apiUrls.medications.importSynonymsListCSVFile, file);

export const importHighRiskSupplementsListCSVFile = (file: File) =>
  upload<IImportHighRiskSupplementsListResponse>(apiUrls.risksupplements.importcsvfile, file);

export const createNewUserEnteredMedication = (payload: IUserEnteredMedicationData) =>
  postFormWithFiles<IUserEnteredMedicationResponseDto>(
    apiUrls.userEnteredMedications.create,
    payload,
  );

export const editUserEnteredMedication = (payload: IUserEnteredMedication) =>
  putFormWithFiles<IUserEnteredMedicationResponseDto>(
    apiUrls.userEnteredMedications.update,
    payload,
  );

export const getUserEnteredMedicationDetails = (id: number) =>
  get<IUserEnteredMedicationResponseDto>(`${apiUrls.userEnteredMedications.basicInfo}/${id}`);

export const getMedicationResponseDetails = (medicationId: number) =>
  get<IMedicationResponseDetails>(`${apiUrls.inquiries.medicationResponseDetails}/${medicationId}`);

export const submitMedicationNeedsInfoForm = (payload: ISubmitMedicationNeedsInfoFormPayload) =>
  postFormWithFiles(apiUrls.userEnteredMedications.addNote, payload);

export const markMedicationAsViewed = (medicationInquiryId: number) =>
  post(`${apiUrls.userEnteredMedications.medicationViewed}/${medicationInquiryId}`);
